import ContractGenerationTractDetail from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractGenerationTractDetail';
import Acknowledgement from '../leasing/Acknowledgement';
import ContractAmendment from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAmendment';
import ContractClause from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractClause';
import ContractAddendumClause from 'src/components/project/sections/LeasingComponents/redesign/ContractGenerationModels/ContractAddendumClause';
import IOwner from '../IOwner';
import IContract from './IContract';
import Owner from '../tract_detail/Owner';
import WIContractOwnership from '../tract_detail/WIContractOwnership';
import ProvisionLeaseClause from '../ProvisionLeaseClause';
import AdditionalDamages from '../AdditionalDamages';
import Restriction from '../leasehold/Restriction';

export default class RightOfWay implements IContract {
    id?: number;
    name: string;
    createdDate: Date;
    rowNumber: number;
    rowAgreementType: string;
    leaseDate: Date;
    effectiveDate: Date;
    recordTypeId?: number;
    recordDate: Date;
    constraintDate: Date;
    volume: string;
    page: string;
    instrumentNumber: string;
    isFiledByMemo?: boolean;
    originalLessor: string;
    originalLessee: string;
    lessorAka: string;
    rowLength?: number;
    rowLengthTypeId?: number;
    rowWidth?: number;
    rowWidthTypeId?: number;
    tempWidth?: number;
    tempWidthTypeId?: number;
    numberOfLines?: number;
    pipeLineSize?: number;
    pipeLineSizeTypeId?: number;
    pipeLineNotExceeding?: number;
    notExceedingTypeId?: number;
    consideration?: number;
    considerationType: string;
    extraConsideration?: number;
    extraConsiderationType: string;
    damages?: number;
    damagesType: string;
    damagesPaymentUpFront?: boolean;
    payTermOrder?: number;
    payTermTypeId?: number;
    isRental?: boolean;
    rentalAmount?: number;
    rentalAmountType: string;
    rentalEscalatingPercentage?: number;
    legalDescription: string;
    rteLegalDescription: string;
    isCommitted?: boolean;
    commitDate?: Date;
    isInHand?: boolean;
    inHandDate?: Date;
    isVoid?: boolean;
    voidDate?: Date;
    isGeneratedLease?: boolean;
    isActive?: boolean;
    clientDocNumber: string;
    leasedBy: string;
    reminderNote: string;
    reminderDate?: Date;
    lesseeName: string;
    lesseeAddressLine1: string;
    lesseeAddressLine2: string;
    lesseeCity: string;
    lesseeState: string;
    lesseeZipCode: string;
    lesseePhoneNumber: string;
    lesseeOwnerLookupId?: number;
    isNotOriginalLessee?: boolean;
    leaseLessorNotes: string;
    ownersAddressOnDocument: string;
    ownersOnDocument: string;
    ownersSSNTaxIdOnDocument: string;
    modifiedByUserId?: number;
    originalInHandDate?: Date;
    bonusAmount?: number;
    bonusTypeId?: number;
    originalGrossAcres?: number;
    isPerpetual?: boolean;
    
    // Not Mapped
    invoiceableLookupId?: number;
    currentHold?: RightOfWayHold;
    rightOfWayHolds?: Array<RightOfWayHold>;
    surfaceTracts?: Array<ContractGenerationTractDetail>;
    acknowledgements?: Array<Acknowledgement>;
    amendments?: Array<ContractAmendment>;
    adHocClauses?: Array<ContractClause>;
    contractClauses?: Array<ContractAddendumClause>;
}

export class RightOfWayHold {
    id?: number;
    rightOfWayId?: number;
    rowHoldNumber?: number;
    projectId?: number;
    primaryTerm?: number;
    primaryTermTypeId?: number;
    royalty?: number;
    agreementDate?: Date;
    effectiveDate?: Date;
    expirationDate?: Date;
    agreementType?: string;
    extensionTerm?: number;
    extensionTermTypeId?: number;
    extensionExpirationDate?: Date;
    agentId?: number;
    notes?: string;
    optionExercised?: boolean;
    isActive?: boolean;
    isHistorical?: boolean;
    
    // Not Mapped
    primaryTermType: string;
    extensionTermType: string;
    contractLookupId?: number;
    surfaceOwner: IOwner;
    ownershipId?: number;
    wiOwners?: Array<Owner>;
    contractOwnerships?: Array<WIContractOwnership>;
    provisionLeaseClauses?: Array<ProvisionLeaseClause>;
    additionalDamages?: Array<AdditionalDamages>;
    restrictions?: Array<Restriction>;
}


// WEBPACK FOOTER //
// ./src/models/contract_types/RightOfWay.ts